export type FontLibraryErrorCode =
  | 'FONT_UNKNOWN'
  | 'FONT_BYTES_MISSING'
  | 'FONT_BYTES_INVALID'
  | 'FONT_HASH_MISMATCH'
  | 'FONT_BROWSER_API_UNAVAILABLE'
  | 'FONT_NOT_READY';

export class FontLibraryError extends Error {
  readonly code: FontLibraryErrorCode;
  readonly details: Readonly<Record<string, unknown>>;

  constructor(
    code: FontLibraryErrorCode,
    message: string,
    details: Readonly<Record<string, unknown>> = {},
    options?: ErrorOptions,
  ) {
    super(message, options);
    this.name = 'FontLibraryError';
    this.code = code;
    this.details = details;
  }
}
